// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codman-comparison-picker-button {
  height: var(--spacing5);
  line-height: var(--spacing5);
  border-radius: 4px;
  display: inline-flex;
  vertical-align: middle;
  margin-left: var(--spacing1);
  cursor: pointer;
  border: 1px solid transparent;
  position: relative;
}
.codman-comparison-picker-button .codman-comparison-picker-button__icon .lg-icon {
  height: var(--spacing1);
  width: var(--spacing1);
  margin: var(--spacing1);
}
.codman-comparison-picker-button .codman-comparison-picker-button__text-basic {
  margin-right: var(--spacing1);
}
.codman-comparison-picker-button .codman-comparison-picker-button__count {
  font-weight: 600;
  margin-right: var(--spacing1);
}
.codman-comparison-picker-button .codman-comparison-picker-button__icon-close {
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgb(var(--white));
  border-radius: 4px;
  color: rgb(var(--gray-color-60));
  display: none;
}
.codman-comparison-picker-button .codman-comparison-picker-button__icon-close:hover {
  color: rgb(var(--black));
  box-shadow: 0px 1px 6px var(--shadow-gray-dark);
}
.codman-comparison-picker-button:hover .codman-comparison-picker-button__icon-close {
  display: block;
}
.codman-comparison-picker-button.codman-comparison-picker-button--ownProvider {
  background-color: #e6f6f7;
}
.codman-comparison-picker-button.codman-comparison-picker-button--ownProvider .codman-comparison-picker-button__icon .lg-icon {
  color: #00a3ad;
}
.codman-comparison-picker-button.codman-comparison-picker-button--ownProvider:hover {
  border-color: #bae6e7;
}
.codman-comparison-picker-button.codman-comparison-picker-button--nationalBenchmark {
  background-color: rgb(var(--gray-color-5));
}
.codman-comparison-picker-button.codman-comparison-picker-button--nationalBenchmark .codman-comparison-picker-button__icon .lg-icon {
  color: #b0b0b0;
}
.codman-comparison-picker-button.codman-comparison-picker-button--nationalBenchmark:hover {
  border-color: rgb(var(--gray-color-25));
}
.codman-comparison-picker-button.codman-comparison-picker-button--connectBenchmark {
  background-color: #f0e6ff;
}
.codman-comparison-picker-button.codman-comparison-picker-button--connectBenchmark .codman-comparison-picker-button__icon .lg-icon {
  color: #c79dff;
}
.codman-comparison-picker-button.codman-comparison-picker-button--connectBenchmark:hover {
  border-color: #e1cffc;
}
.codman-comparison-picker-button.codman-comparison-picker-button--1 {
  background-color: #e8ebff;
}
.codman-comparison-picker-button.codman-comparison-picker-button--1 .codman-comparison-picker-button__icon .lg-icon {
  color: #6a8dff;
}
.codman-comparison-picker-button.codman-comparison-picker-button--1:hover {
  border-color: #d2ddff;
  background-color: #e9eeff;
}
.codman-comparison-picker-button.codman-comparison-picker-button--2 {
  background-color: #fbe6f8;
}
.codman-comparison-picker-button.codman-comparison-picker-button--2 .codman-comparison-picker-button__icon .lg-icon {
  color: #e75ad9;
}
.codman-comparison-picker-button.codman-comparison-picker-button--2:hover {
  border-color: #f8cdf4;
  background-color: #fbe6f9;
}
.codman-comparison-picker-button.codman-comparison-picker-button--3 {
  background-color: #fde9d8;
}
.codman-comparison-picker-button.codman-comparison-picker-button--3 .codman-comparison-picker-button__icon .lg-icon {
  color: #e7a33a;
}
.codman-comparison-picker-button.codman-comparison-picker-button--3:hover {
  border-color: #f8e3c4;
  background-color: #fbf1e2;
}

.codman-comparison-picker-button__link {
  text-decoration: underline;
  cursor: pointer;
  margin-left: var(--spacing0);
  color: rgb(var(--base-60));
}`, "",{"version":3,"sources":["webpack://./libs/shared/feature-comparison-picker/src/lib/comparison-picker-info/comparison-picker-button-info/comparison-picker-button-info.component.scss"],"names":[],"mappings":"AAEA;EACI,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AADJ;AAIQ;EACI,uBAAA;EACA,sBAAA;EACA,uBAAA;AAFZ;AAMI;EACI,6BAAA;AAJR;AAOI;EACI,gBAAA;EACA,6BAAA;AALR;AAQI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mCAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;AANR;AAQQ;EACI,wBAAA;EACA,+CAAA;AANZ;AAWQ;EACI,cAAA;AATZ;AAaI;EACI,yBAAA;AAXR;AAcY;EACI,cAAA;AAZhB;AAgBQ;EACI,qBAAA;AAdZ;AAkBI;EACI,0CAAA;AAhBR;AAmBY;EACI,cAAA;AAjBhB;AAqBQ;EACI,uCAAA;AAnBZ;AAuBI;EACI,yBAAA;AArBR;AAwBY;EACI,cAAA;AAtBhB;AA0BQ;EACI,qBAAA;AAxBZ;AA0CI;EACI,yBAAA;AAxCR;AA2CY;EACI,cAAA;AAzChB;AA6CQ;EACI,qBAAA;EACA,yBAAA;AA3CZ;AA+CI;EACI,yBAAA;AA7CR;AAgDY;EACI,cAAA;AA9ChB;AAkDQ;EACI,qBAAA;EACA,yBAAA;AAhDZ;AAoDI;EACI,yBAAA;AAlDR;AAqDY;EACI,cAAA;AAnDhB;AAuDQ;EACI,qBAAA;EACA,yBAAA;AArDZ;;AA0DA;EACI,0BAAA;EACA,eAAA;EACA,4BAAA;EACA,0BAAA;AAvDJ","sourcesContent":["@use \"definitions\" as *;\n\n.codman-comparison-picker-button {\n    height: var(--spacing5);\n    line-height: var(--spacing5);\n    border-radius: 4px;\n    display: inline-flex;\n    vertical-align: middle;\n    margin-left: var(--spacing1);\n    cursor: pointer;\n    border: 1px solid transparent;\n    position: relative;\n\n    .codman-comparison-picker-button__icon {\n        .lg-icon {\n            height: var(--spacing1);\n            width: var(--spacing1);\n            margin: var(--spacing1);\n        }\n    }\n\n    .codman-comparison-picker-button__text-basic {\n        margin-right: var(--spacing1);\n    }\n\n    .codman-comparison-picker-button__count {\n        font-weight: 600;\n        margin-right: var(--spacing1);\n    }\n\n    .codman-comparison-picker-button__icon-close {\n        position: absolute;\n        right: 0;\n        top: 0;\n        background-color: lg-color(--white);\n        border-radius: 4px;\n        color: lg-color(--gray-color-60);\n        display: none;\n\n        &:hover {\n            color: lg-color(--black);\n            box-shadow: 0px 1px 6px var(--shadow-gray-dark);\n        }\n    }\n\n    &:hover {\n        .codman-comparison-picker-button__icon-close {\n            display: block;\n        }\n    }\n\n    &.codman-comparison-picker-button--ownProvider {\n        background-color: #e6f6f7;\n\n        .codman-comparison-picker-button__icon {\n            .lg-icon {\n                color: #00a3ad;\n            }\n        }\n\n        &:hover {\n            border-color: #bae6e7;\n        }\n    }\n\n    &.codman-comparison-picker-button--nationalBenchmark {\n        background-color: lg-color(--gray-color-5);\n\n        .codman-comparison-picker-button__icon {\n            .lg-icon {\n                color: #b0b0b0;\n            }\n        }\n\n        &:hover {\n            border-color: lg-color(--gray-color-25);\n        }\n    }\n\n    &.codman-comparison-picker-button--connectBenchmark {\n        background-color: #f0e6ff;\n\n        .codman-comparison-picker-button__icon {\n            .lg-icon {\n                color: #c79dff;\n            }\n        }\n\n        &:hover {\n            border-color: #e1cffc;\n        }\n    }\n\n    // &.codman-comparison-picker-button--regionalBenchmark {\n    //     background-color: #f0f4ff;\n\n    //     .codman-comparison-picker-button__icon {\n    //         .lg-icon {\n    //             color: #98acff;\n    //         }\n    //     }\n\n    //     &:hover {\n    //         border-color: #c3d1ff;\n    //     }\n    // }\n\n    &.codman-comparison-picker-button--1 {\n        background-color: #e8ebff;\n\n        .codman-comparison-picker-button__icon {\n            .lg-icon {\n                color: #6a8dff;\n            }\n        }\n\n        &:hover {\n            border-color: #d2ddff;\n            background-color: #e9eeff;\n        }\n    }\n\n    &.codman-comparison-picker-button--2 {\n        background-color: #fbe6f8;\n\n        .codman-comparison-picker-button__icon {\n            .lg-icon {\n                color: #e75ad9;\n            }\n        }\n\n        &:hover {\n            border-color: #f8cdf4;\n            background-color: #fbe6f9;\n        }\n    }\n\n    &.codman-comparison-picker-button--3 {\n        background-color: #fde9d8;\n\n        .codman-comparison-picker-button__icon {\n            .lg-icon {\n                color: #e7a33a;\n            }\n        }\n\n        &:hover {\n            border-color: #f8e3c4;\n            background-color: #fbf1e2;\n        }\n    }\n}\n\n.codman-comparison-picker-button__link {\n    text-decoration: underline;\n    cursor: pointer;\n    margin-left: var(--spacing0);\n    color: lg-color(--base-60);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
